import { Card, CardBody, Col, Row } from 'reactstrap'
import { H6, P } from '../../../../AbstractElements'
import { articleDataOne } from '../../../../Data/Miscellaneous/Faq/Faq'

const ArticleVideo1 = () => {
  return (
    <Col xl="4" md="6">
      <Row>
        {articleDataOne.map((item, i) => (
          <Col sm="12" key={i}>
            <Card>
              <CardBody>
                <div className='d-flex'>
                  {item.iconClass}
                  <div className="flex-grow-1">
                    <H6 className="f-w-600">{item.title}</H6>
                    <P>{item.description}</P>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </Col>
  )
}

export default ArticleVideo1